interface SizeRow {
  size: string;
  guests: string;
  footprint: string;
  bestFor: string;
  highlight?: boolean;
}

const rows: SizeRow[] = [
  {
    size: '3m × 6m',
    guests: 'Up to 15',
    footprint: '18 m²',
    bestFor: 'Intimate garden parties, small private dinners',
  },
  {
    size: '5m × 8m',
    guests: '20 – 40',
    footprint: '40 m²',
    bestFor: 'Birthday parties, engagement celebrations',
  },
  {
    size: '6m × 9m',
    guests: '40 – 60',
    footprint: '54 m²',
    bestFor: 'Corporate lunches, cocktail receptions',
    highlight: true,
  },
  {
    size: '8m × 12m',
    guests: '60 – 100',
    footprint: '96 m²',
    bestFor: 'Wedding ceremonies, mid-size festivals',
    highlight: true,
  },
  {
    size: '10m × 15m',
    guests: '100 – 150',
    footprint: '150 m²',
    bestFor: 'Large weddings, brand activations, exhibitions',
  },
  {
    size: '12m × 18m',
    guests: '150 – 250',
    footprint: '216 m²',
    bestFor: 'Major outdoor events, trade shows, festivals',
  },
  {
    size: 'Custom / Linked',
    guests: '250+',
    footprint: 'Tailored',
    bestFor: 'Multi-zone festivals, stadiums, corporate campuses',
  },
];

export default function SizingTable() {
  return (
    <div className="overflow-x-auto rounded-2xl border border-gray-100 mt-6">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-teal-500 text-white">
            <th className="text-left px-5 py-4 font-bold">Tent Size</th>
            <th className="text-left px-5 py-4 font-bold">Guest Capacity</th>
            <th className="text-left px-5 py-4 font-bold">Footprint</th>
            <th className="text-left px-5 py-4 font-bold">Best For</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr
              key={row.size}
              className={`border-t border-gray-100 transition-colors ${
                row.highlight
                  ? 'bg-teal-50'
                  : i % 2 === 0
                  ? 'bg-white'
                  : 'bg-gray-50/50'
              }`}
            >
              <td className="px-5 py-4 font-bold text-gray-900">{row.size}</td>
              <td className="px-5 py-4 text-gray-700">{row.guests}</td>
              <td className="px-5 py-4 text-gray-700">{row.footprint}</td>
              <td className="px-5 py-4 text-gray-600">{row.bestFor}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
